import { darken } from 'polished';
import styled, { css } from 'styled-components';
import Input from '../../../../../../newComponents/UnformInput';

export const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 20px 32px 32px;
  font-family: 'Sora', sans-serif;

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  margin-bottom: 25px;

  h2 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #101d40;
  }

  p {
    color: #7c8db5;
    font-size: 14px;
  }

  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

export const SizesList = styled.ul`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: initial;
  }
`;

export const SizeItem = styled.li`
  border: 2px solid #e6effb;
  border-radius: 5px;
  width: initial;

  @media (min-width: 768px) {
    width: calc(50% - 7.5px);
  }
`;

export const SizeItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 2px solid #e6effb;

  h3 {
    font-size: 16px;
    color: #101d40;
    font-weight: 600;
    letter-spacing: 0px;
  }
`;

export const SizeItemBody = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  padding: 10px;

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
`;

export const HelpButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  font-family: 'Sora', sans-serif;
  font-weight: 500;
  height: 38px;
  background-color: #329bfc;
  color: #ffffff;
  font-size: 13px;
  border: none;
  border-radius: 5px;
  margin-top: 26px;

  &:hover {
    background-color: ${darken(0.1, '#329bfc')};
  }
`;
